"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _customization = require("@insided/shared/services/customization");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _SSIFooter = _interopRequireDefault(require("./SSIFooter"));

var _CustomFooter = _interopRequireDefault(require("./CustomFooter"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'footer';
exports.cssAnchorName = cssAnchorName;

var FooterComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FooterComponent, _Component);

  var _super = _createSuper(FooterComponent);

  function FooterComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, FooterComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      type: _this.props.type,
      customFooter: {
        html: _this.props.customFooter
      },
      ssiFooter: {
        url: _this.props.ssiFooterUrl,
        ssiHtml: _this.props.ssiFooterHtml
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFooterConfigChangeEvent", function (event) {
      if (event instanceof CustomEvent && event.detail) {
        _this.setState(event.detail.value);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFooterConfigResetEvent", function () {
      _this.setState({
        type: _this.props.type,
        customFooter: {
          html: _this.props.customFooter
        },
        ssiFooter: {
          url: _this.props.ssiFooterUrl,
          ssiHtml: _this.props.ssiFooterHtml
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(FooterComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('footerConfigChange', this.handleFooterConfigChangeEvent);
      window.addEventListener('footerConfigReset', this.handleFooterConfigResetEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('footerConfigChange', this.handleFooterConfigChangeEvent);
      window.removeEventListener('footerConfigReset', this.handleFooterConfigResetEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          type = _this$state.type,
          ssiFooter = _this$state.ssiFooter,
          customFooter = _this$state.customFooter;
      return (0, _preact.h)("div", null, type === 'default' && (0, _preact.h)("section", {
        className: (0, _classnames.default)(['full-width', 'Template-brand-footer', 'footer-area', 'custom-footer']),
        style: {
          marginTop: 'auto'
        }
      }, (0, _preact.h)("footer", {
        className: (0, _classnames.default)(['brand-footer-wrapper', 'qa-brand-footer', 'p-v content--centered'])
      }, (0, _preact.h)(_phrase.default, {
        p: "branded.back_to_top",
        renderAsText: true
      }, function (phrase) {
        return (0, _preact.h)("a", {
          href: "#",
          className: "js-scrollto back-to-top",
          style: (0, _customization.isCustomizationMode)() ? {
            opacity: 0
          } : {}
        }, phrase);
      }))), type === 'ssi' && ssiFooter.url && (0, _preact.h)(_SSIFooter.default, {
        url: ssiFooter.url,
        initialHtml: ssiFooter.ssiHtml,
        html: ssiFooter.ssiHtml
      }), type === 'custom' && customFooter && (0, _preact.h)(_CustomFooter.default, {
        html: customFooter.html
      }));
    }
  }]);
  return FooterComponent;
}(_preact.Component);

var _default = FooterComponent;
exports.default = _default;